// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Y62t4","md":"Button_md__O+dtN","lg":"Button_lg__72Z8p","primary":"Button_primary__NGIIN","secondary":"Button_secondary__FdhUX","ghost":"Button_ghost__tLrp+"};